// @flow
import styled from '@emotion/styled';

export const DeveloperHomePage = styled.div`
  background-color: ${props => props.theme.COLORS.GRAY_10};
`;
